import * as React from "react";
import { sliderRevo, sliderRevoTwo, sliderRevoThree } from "src/assets/images";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "src/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay"; // ✅ Correct Import for Embla

const Sliderimages = [
    {
        src: sliderRevo,
        title: "Transforming Visions into Reality: Experience the Future of African fabrics",
    },
    {
        src: sliderRevoTwo,
        title: "Transforming Visions into Reality: Experience the Future of African fabrics",
    },
    {
        src: sliderRevoThree,
        title: "Transforming Visions into Reality: Experience the Future of African fabrics",
    },
];

export function CarouselDemo() {
    return (
        <Carousel
            className="w-full lg:w-[100%] mx-auto relative"
            plugins={[
                Autoplay({
                    delay: 8000,
                }),
            ]}
            options={{
                speed: 20, // Lower is slower and smoother (default is 10)
                loop: true,
                align: "start", // optional, for snap position
            }}
        >
            <CarouselContent className="h-full">
                {Sliderimages.map((item, index) => (
                    <CarouselItem key={index} className="h-full relative">
                        <div className="relative w-full h-full">
                            {/* Background Image */}
                            <img
                                src={item.src}
                                alt={`Slide ${index + 1}`}
                                className="w-full hero-section-rate object-cover object-[50%_20%]"
                            />

                            {/* Overlay Content */}
                            <div className="absolute inset-0 flex flex-col items-center justify-end text-center text-white bg-black/40 p-4 fatix-auda-media">
                                <h2 className="text-2xl font-bold slider-title">{item.title}</h2>
                                <a className="text-white px-20 py-3 rounded-lg shop-class" href="/shop">
                                    Shop Now
                                </a>
                            </div>
                        </div>
                    </CarouselItem>
                ))}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
        </Carousel>
    );
}

